module.exports = __webpack_public_path__ + "static/media/13.88184b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/13.png
// module id = 650
// module chunks = 0